<template>
    <div>
        <div class="holder">
            <div class="container-fluid">
                <div class="m-auto text-center mt-4" v-if="loading"><Loader/></div>
                <div v-else class="row">
                    <div class="col-md-8">
                        <div class="top-holder">
                            <p @click="backBtn()" class="back-text"><span><i class="fa fa-chevron-left"></i></span>Back</p>
                            <!-- <div>
                                <button class="btn"><img src="../assets/icons/export-upload.svg" alt="download">Landlord Agreement</button>
                            </div> -->
                        </div>

                        <div class="left-holder">
                            <div class="prop-title">
                                <h3>{{ properties.title }}</h3>
                                <h6>{{properties.pin}}</h6>
                                <p>{{properties.address}}</p>
                            </div>
                            <hr>
                            <h4 class="text-header">About this property</h4>
                            <div class="about-prop">
                                <p>{{properties.description }} </p>
                                <!-- <small>See more</small> -->
                            </div>
                            <hr>
                            <div>
                                <div class="d-flex justify-content-between">
                                    <h4 class="text-header">Property overview</h4>

                                    <span style="cursor: pointer;" @click="showOverview = !showOverview"><i class="fa" :class="[showOverview ? 'fa-chevron-up' : 'fa-chevron-down']"></i></span>
                                </div>
                                <div class="row mt-3" v-if="showOverview">
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Property type</h6>
                                            <h5>{{properties.typename}}</h5>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Property subtype</h6>
                                            <h5>{{properties.subtypename}}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Business type</h6>
                                            <h5>{{properties.businesstypename}}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Units</h6>
                                            <h5>{{ properties.units }}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>State</h6>
                                            <h5>{{properties.state}}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>City</h6>
                                            <h5>{{properties.city}}</h5>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                            </div>
                            <div>
                                <div class="d-flex justify-content-between">
                                    <h4 class="text-header">Landlord’s contact info</h4>

                                    <span style="cursor: pointer;" @click="showLandlord = !showLandlord"><i class="fa" :class="[showLandlord ? 'fa-chevron-up' : 'fa-chevron-down']"></i></span>
                                </div>
                                <div class="row mt-3" v-if="showLandlord">
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Landlord name</h6>
                                            <h5>{{landlordDetails.firstname}} {{landlordDetails.lastname}}</h5>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Email address</h6>
                                            <h5>{{landlordDetails.email}}</h5>
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="overview-data">
                                            <h6>Phone number</h6>
                                            <h5>{{landlordDetails.phone}}</h5>
                                        </div>
                                    </div>
                                    
                                </div>
                                <hr>

                                <div>
                                    <h4 class="text-header mt-4">Units</h4>

                                    <div class="unit-holder">
                                        <!-- <div class="search-holder">
                                            <div class="form-group d-flex justify-content-between">
                                                <input class="form-control input-field search" type="text" name="search" id="search" placeholder="Search by tenant name">
                                                <button class="btn clear-btn"><span><i class="fa fa-filter"></i></span> Filter</button>
                                            </div>
                                        </div> -->
                                        <div class="table-responsive tableList">
                                            <!-- <div class="m-auto text-center mt-4 d-none" v-if="loadingDashboard"><Loader/></div> -->
                                            <!-- <table class="table" v-if="!loadingDashboard && assingedFMArray.length != 0"> -->
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Unit name</th>
                                                        <th scope="col">Tenant name</th>
                                                        <th scope="col">Rent type</th>
                                                        <th scope="col">Next rent due</th>
                                                        <th scope="col">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-for="(item, index) in units" :key="index">
                                                    <tr>
                                                        <td>{{ item.nomenclature_serial }}</td>
                                                        <td>{{item.tenant}}</td>
                                                        <td>{{item.harmonised_rent == 'YES' ? 'Harmonized' : item.guaranteed_rent == 'YES' ? 'Guarenteed' : '--'}}</td>
                                                        <td v-if="item.next_rent_due != null">{{item.next_rent_due | moment}}</td>
                                                        <td v-else>--</td>
                                                        <td><span class="occupied" :class="[item.status == 'vacant' ? 'vacant' : 'occupied']">{{item.status != null ? item.status : '--' }}</span></td>
                                                    </tr>
                                                    
                                                    <!-- <tr v-for="(item, index) in assingedFMArray"
                                                        :key="index"
                                                        :value="item.id">
                                                        <td>{{index + 1}}</td>
                                                        <td>{{item.user.firstname}} {{item.user.lastname}}</td>
                                                        <td>{{item.user.email}}</td>
                                                        <td>{{item.user.phone}}</td>
                                                        <td>{{ item.user.address }}</td>
                                                    </tr> -->
                                                
                                                </tbody>
                                            </table>
                                            <!-- <div v-if="assingedFMArray.length == 0 && !loadingDashboard">
                                                <EmptyState :emptyData="emptyDataObject" />
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="right-holder">
                            <h4 class="text-header">Rent disbursement history</h4>
                            <hr>
                            <div v-for="(item, index) in rentDisbursments" :key="index">
                                <div class="disbursement-items" >
                                    <div>
                                        <h4>Unit {{ item.unit_name }}</h4>
                                        <h5>Disbursed: ₦{{Number(item.amount).toLocaleString()}}</h5>
                                    </div>
                                    <h6>{{item.date | moment}}</h6>
                                </div>
                                <hr>
                            </div>

                            <h4 class="text-header">Assigned team</h4>
                            <hr>
                            <div class="profile-container">
                                <img src="@/assets/profileImage.jpg" alt="Profile Picture" class="profile-pic">
                                <div class="profile-info" v-if="inspectionOfficer">
                                    <h3>{{ inspectionOfficer.firstname }} {{ inspectionOfficer.lastname }}</h3>
                                    <p>{{inspectionOfficer.email}}</p>
                                    <p>{{ inspectionOfficer.phone }}</p>
                                    <p>Inspection officer</p>
                                </div>
                            </div>
                            <div class="profile-container">
                                <img src="@/assets/profileImage.jpg" alt="Profile Picture" class="profile-pic">
                                <div class="profile-info" v-if="facilityManager">
                                    <h3>{{ facilityManager.firstname }} {{ facilityManager.lastname }}</h3>
                                    <p>{{facilityManager.email}}</p>
                                    <p>{{ facilityManager.phone }}</p>
                                    <p>Facility manager</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import properties from "../services/properties";
import moment from 'moment';
import Loader from '../components/Loader';
export default {
    name: "LandlordPropertyDetails",
    components: {
        Loader,
        // EmptyState
    },
    // props: {
    //     emptyData: {
    //         type: Object,
    //         required: true,
    //     }
    // },
    data() {
        return {
            loading: false,
            activeTab: 1,
            showOverview: false,
            showLandlord: false,
            batchNumber: "",
            properties: '',
            rentDisbursments: [],
            units: [],
            landlordDetails: "",
            inspectionOfficer: "",
            facilityManager: "",
        }
    },
    created() {
        this.batchNumber = this.$route.params.id;
    },
    mounted() {
        this.fetchPropertyDetails();
    },
    methods: {
        backBtn() {
            this.$router.push({path: `/user/partner/landlord-details/${this.landlordDetails.id}`});
        },
        // moveToUnitDetails() {
        //     this.$router.push({path: `/user/partner/unit-details`});
        // }

        async fetchPropertyDetails() {
            this.loading = true;
            try {
                if(this.batchNumber != '' || this.batchNumber != null) {
                    await properties.fetchPropertiesByBatch(this.batchNumber).then(res => {
                        // console.log("Properties", res);
                        this.loading = false;
                        if(res.success) {
                            this.properties = res.property[0];
                            this.rentDisbursments = res.rent_disbursment;
                            this.units = res.units;
                            this.landlordDetails = res.property[0].landlord;
                            this.inspectionOfficer = res.property[0].inspection_officer;
                            this.facilityManager = res.property[0].facility_manager;
                        }
                        if(res.error) {
                            this.$toast.error(res.error);
                        }
                    }).catch((err) => {
                        this.loading = false;
                        console.log(err);
                        // this.$toast.error("please check your network and refresh the page");
                    })
                }
            } finally {
                // console.log("closed");
            }
        },
    },
    filters: {
        moment: function(date) {
        return moment(date).format('MMMM Do YYYY');
        }
        // moment: function(date) {
        //   return moment(date).format('MMMM DD YYYY, h:mm:ss a');
        // }
    },
    immediate: true
}
</script>


<style scoped lang="scss">

.top-holder {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    button {
        img {
            padding-right: 10px;
        }
        border: 1px solid #D5D7DA;
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        color: #414651;
        border-radius: 6px;
        outline: 0;
        box-shadow: none;
    }
}
.holder {
    background: #ffffff;
    padding: 30px 15px;
}
.back-text {
   font-family: Lato;
   font-weight: 600;
   font-size: 16px;
   line-height: 24px;
   color: #535862;
   margin-bottom: 20px !important;
   cursor: pointer;
   span {
      padding-right: 10px;
   }
}

.prop-title {
    h3, span {
        font-family: Lato;
        font-size: 24px;
        color: #2B3352;
    }
    h3 {
        font-weight: 600;
    }
    h6 {
        font-weight: 400;
        font-family: Lato;
        font-size: 20px;
        color: #2B3352;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #555C74;
    }
}

.text-header {
    font-family: Lato;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    color: #2B3352;
}

.about-prop {
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #555C74;
        margin-bottom: 20px !important;
    }
    small {
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #0033EA;
        padding-top: 20px;
    }
}

.overview-data {
    margin-bottom: 30px;
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        color: #555C74;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #2B3352;
    }
}

.input-field {
    height: 48px;
    outline: 0;
    box-shadow: none;
}

.search {
   width: 50%; 
   border-radius: 8px;
}

.clear-btn {
    border: 1px solid #D5D7DA;
    color: #414651;
    font-family: Lato;
    font-weight: 600;
    font-size: 14px;
    outline: 0;
    box-shadow: none;
}

.unit-holder {
    border: 1px solid #E9EAEB;
    border-radius: 12px;
}
.search-holder {
    padding: 20px;
}

input, select {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #414651;
}

.select-stack {
  display: inline-block;
  width: calc(25.33% - 10px); /* Show in a row on larger screens */
  margin-right: 5px;
  border-radius: 8px;
  outline: 0;
  box-shadow: none;
}

.table-responsive {
    margin-bottom: 0 !important;
}
.tableList {
    // margin-top: 30px;
    // margin-bottom: 20px;
    // border: 2px solid #EAECF0;
    // border-radius: 20px;
    // border-bottom: 0;
}


.table thead th {
    border-bottom: none;
    
}
.table td {
    border-top: 1px solid #EAECF0;
}
.table th {
    border-top: none;
}

thead > tr {
    // background: #EAECF0;
    background: #E9EAEB;
}
thead th {
    white-space: nowrap;
    font-family: Lato;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    // color: #667085
    color: #555C74;
}

tbody td {
    padding: 18px .75rem;
    white-space: nowrap;
    font-family: Lato;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #555C74;
    // color: #667085
}

.occupied {
    color: #B42318;
    font-family: Lato;
    font-weight: 500;
    font-size: 11px;
    background: #FEF3F2;
    border: 1px solid #FECDCA;
    border-radius: 50px;
    padding: 2px 6px;

}
.vacant {
    color: #067647;
    font-family: Lato;
    font-weight: 500;
    font-size: 11px;
    background: #ECFDF3;
    border: 1px solid #ABEFC6;
    border-radius: 50px;
    padding: 2px 6px;
}



.right-holder {
    border-left: 1px solid #E9EAEB;
    padding-left: 15px;
}
.disbursement-items {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    h4, h5 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
    }
    h4 {
        font-weight: 500;
        color: #2B3352;
    }
    h5 {
        font-weight: 400;
        color: #555C74;
    }
}

.profile-container {
  display: flex;
  align-items: flex-start;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 10px;
  max-width: 400px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
}

.profile-pic {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 15px;
}

.profile-info {
  flex: 1;
}

.profile-info h3 {
  margin: 0;
  font-size: 18px;
  font-family: Lato;
}

.profile-info p {
  margin: 3px 0;
  font-size: 14px;
  color: #555;
  font-family: Lato;
}
@media (max-width: 768px) {
  .select-stack {
    display: block;
    width: 100%; /* Stack on smaller screens */
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 599px) {
    .search {
      width: 63%; 
    }
    .right-holder {
        margin-top: 40px;
        border-left: none;
        padding-left: none
    }
}
</style>